import { render, staticRenderFns } from "./PromotionDappStepReward.vue?vue&type=template&id=eb8ff74e&scoped=true&"
import script from "./PromotionDappStepReward.vue?vue&type=script&lang=js&"
export * from "./PromotionDappStepReward.vue?vue&type=script&lang=js&"
import style0 from "./PromotionDappStepReward.vue?vue&type=style&index=0&id=eb8ff74e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb8ff74e",
  null
  
)

export default component.exports